import { render, staticRenderFns } from "./PLabel.vue?vue&type=template&id=5c787a3f&scoped=true&"
import script from "./PLabel.vue?vue&type=script&lang=ts&"
export * from "./PLabel.vue?vue&type=script&lang=ts&"
import style0 from "./PLabel.vue?vue&type=style&index=0&id=5c787a3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c787a3f",
  null
  
)

export default component.exports